export default "__VITE_ASSET__CCmehRpw__"